export const CONFIRM_CODE_OPTIONS = [
    {value: 1, label: '系统问题'},
    {value: 2, label: '同步延迟'},
    {value: 3, label: '其他'},
];
